module.exports = __webpack_public_path__ + "static/media/cprosChecked.75f8dfbf.svg";